import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// 디자인 토큰 → 폰트 → 글로벌 reset 순서로 로드. 토큰이 먼저 들어와야 fonts.css가 var(...)를 못 참조해도 안전.
import './styles/tokens.css';
import './styles/fonts.css';
import './styles/global.css';

import App from './App';
import { ToastProvider } from './components/ui/Toast';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('root element not found');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
